import { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { me, logout } from "../api";
import "./NavBar.css";
import logo from "../assets/LOGO - FOOTER.png";

export default function NavBar({ user: parentUser }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(parentUser || null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [avatarOpen, setAvatarOpen] = useState(false);

  useEffect(() => {
    if (!parentUser) {
      me().then((r) => {
        if (r.user) setUser(r.user);
      });
    } else {
      setUser(parentUser);
    }
  }, [parentUser]);

  const roleHome = (role) =>
    role === "admin"
      ? "/admin"
      : role === "psicologa"
        ? "/psicologia"
        : role === "logopeda"
          ? "/logopedia"
          : role === "nutricionista"
            ? "/nutricion"
            : "/";

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const linkClass = ({ isActive }) => `navlink ${isActive ? "active" : ""}`;

  const closeMenu = () => setMenuOpen(false);

  const userInitial =
    user?.nombre?.charAt(0)?.toUpperCase() ||
    user?.email?.charAt(0)?.toUpperCase() ||
    "U";

  const IconLink = ({ to, icon, title, end = false }) => (
    <NavLink to={to} end={end} className={linkClass} title={title}>
      <i className={`fa-solid ${icon}`} />
    </NavLink>
  );

  const MobileLink = ({ to, icon, label }) => (
    <NavLink to={to} onClick={closeMenu}>
      <i className={`fa-solid ${icon}`} />
      <span>{label}</span>
    </NavLink>
  );

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to={roleHome(user?.role)}>
          <img src={logo} alt="TeAyudo" className="brand-logo" />
        </Link>

        <div className="navbar-links desktop-only">
          {user?.role === "admin" && (
            <>
              <IconLink to="/admin" end icon="fa-house" title="Inicio" />
              <IconLink
                to="/admin/pacientes"
                icon="fa-users"
                title="Lista de pacientes"
              />
              <IconLink
                to="/admin/paciente"
                icon="fa-user-plus"
                title="Nuevo paciente"
              />
              <IconLink
                to="/admin/sesion"
                icon="fa-calendar-plus"
                title="Agendar sesión"
              />
              <IconLink
                to="/admin/calendario"
                icon="fa-calendar-days"
                title="Calendario"
              />
              <IconLink to="/recursos" icon="fa-folder-open" title="Recursos" />
              <IconLink
                to="/admin/comunicaciones"
                icon="fa-paper-plane"
                title="Comunicaciones"
              />
              <IconLink to="/admin/pagos" icon="fa-credit-card" title="Pagos" />
              <IconLink
                to="/admin/usuarios"
                icon="fa-users-gear"
                title="Usuarios"
              />
            </>
          )}

          {user?.role === "psicologa" && (
            <>
              <IconLink to="/psicologia" end icon="fa-house" title="Inicio" />
              <IconLink
                to="/psicologia/pacientes-psicologia"
                icon="fa-users"
                title="Mis pacientes"
              />
              <IconLink
                to="/psicologia/calendario"
                icon="fa-calendar-days"
                title="Calendario"
              />
              <IconLink to="/recursos" icon="fa-folder-open" title="Recursos" />
              <IconLink
                to="/psicologia/pagos"
                icon="fa-credit-card"
                title="Pagos"
              />
            </>
          )}

          {user?.role === "logopeda" && (
            <>
              <IconLink to="/logopedia" end icon="fa-house" title="Inicio" />
              <IconLink
                to="/logopedia/pacientes-logopedia"
                icon="fa-users"
                title="Mis pacientes"
              />
              <IconLink
                to="/logopedia/calendario"
                icon="fa-calendar-days"
                title="Calendario"
              />
              <IconLink to="/recursos" icon="fa-folder-open" title="Recursos" />
              <IconLink
                to="/logopedia/pagos"
                icon="fa-credit-card"
                title="Pagos"
              />
            </>
          )}

          {user?.role === "nutricionista" && (
            <>
              <IconLink to="/nutricion" end icon="fa-house" title="Inicio" />
              <IconLink
                to="/nutricion/pacientes-nutricion"
                icon="fa-users"
                title="Mis pacientes"
              />
              <IconLink
                to="/nutricion/calendario"
                icon="fa-calendar-days"
                title="Calendario"
              />
              <IconLink to="/recursos" icon="fa-folder-open" title="Recursos" />
              <IconLink
                to="/nutricion/pagos"
                icon="fa-credit-card"
                title="Pagos"
              />
            </>
          )}
        </div>

        <button
          className={`burger-btn mobile-only ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className="navbar-right">
        <div className="user-avatar-wrapper">
          <button
            type="button"
            className="user-avatar"
            onClick={() => setAvatarOpen((prev) => !prev)}
            title={user?.email || "Usuario"}
          >
            {userInitial}
          </button>

          {avatarOpen && (
            <div className="avatar-menu">
              <div className="avatar-email">{user?.email}</div>

              <button type="button" onClick={handleLogout}>
                <i className="fa-solid fa-right-from-bracket" />
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>

      <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
        {user?.role === "admin" && (
          <>
            <MobileLink to="/admin" icon="fa-house" label="Inicio" />
            <MobileLink
              to="/admin/pacientes"
              icon="fa-users"
              label="Pacientes"
            />
            <MobileLink
              to="/admin/paciente"
              icon="fa-user-plus"
              label="Nuevo paciente"
            />
            <MobileLink
              to="/admin/sesion"
              icon="fa-calendar-plus"
              label="Agendar sesión"
            />
            <MobileLink
              to="/admin/calendario"
              icon="fa-calendar-days"
              label="Calendario"
            />
            <MobileLink to="/recursos" icon="fa-folder-open" label="Recursos" />
            <MobileLink
              to="/admin/comunicaciones"
              icon="fa-paper-plane"
              label="Comunicaciones"
            />
            <MobileLink to="/admin/pagos" icon="fa-credit-card" label="Pagos" />
            <MobileLink
              to="/admin/usuarios"
              icon="fa-users-gear"
              label="Usuarios"
            />
          </>
        )}

        {user?.role === "psicologa" && (
          <>
            <MobileLink to="/psicologia" icon="fa-house" label="Inicio" />
            <MobileLink
              to="/psicologia/pacientes-psicologia"
              icon="fa-users"
              label="Mis pacientes"
            />
            <MobileLink
              to="/psicologia/calendario"
              icon="fa-calendar-days"
              label="Calendario"
            />
            <MobileLink to="/recursos" icon="fa-folder-open" label="Recursos" />
            <MobileLink
              to="/psicologia/pagos"
              icon="fa-credit-card"
              label="Pagos"
            />
          </>
        )}

        {user?.role === "logopeda" && (
          <>
            <MobileLink to="/logopedia" icon="fa-house" label="Inicio" />
            <MobileLink
              to="/logopedia/pacientes-logopedia"
              icon="fa-users"
              label="Mis pacientes"
            />
            <MobileLink
              to="/logopedia/calendario"
              icon="fa-calendar-days"
              label="Calendario"
            />
            <MobileLink to="/recursos" icon="fa-folder-open" label="Recursos" />
            <MobileLink
              to="/logopedia/pagos"
              icon="fa-credit-card"
              label="Pagos"
            />
          </>
        )}

        {user?.role === "nutricionista" && (
          <>
            <MobileLink to="/nutricion" icon="fa-house" label="Inicio" />
            <MobileLink
              to="/nutricion/pacientes-nutricion"
              icon="fa-users"
              label="Mis pacientes"
            />
            <MobileLink
              to="/nutricion/calendario"
              icon="fa-calendar-days"
              label="Calendario"
            />
            <MobileLink to="/recursos" icon="fa-folder-open" label="Recursos" />
            <MobileLink
              to="/nutricion/pagos"
              icon="fa-credit-card"
              label="Pagos"
            />
          </>
        )}
      </div>
    </nav>
  );
}
